var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,2h-5A3.75458,3.75458,0,0,0,5.75,5.75V19.08331A2.9199,2.9199,0,0,0,8.66669,22h6.66662A2.9199,2.9199,0,0,0,18.25,19.08331V5.75A3.75458,3.75458,0,0,0,14.5,2ZM10.33331,3.66663h3.33338a.41669.41669,0,0,1,0,.83337H10.33331a.41669.41669,0,0,1,0-.83337Zm6.25,9.58337a.41677.41677,0,0,1-.41662.41663H7.83331A.41677.41677,0,0,1,7.41669,13.25V5.75a.41679.41679,0,0,1,.41662-.41669h8.33338a.41679.41679,0,0,1,.41662.41669Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.dc373d13c89c36737f029829c36fc361.svg";
export { ForwardRef as ReactComponent };